import { render, staticRenderFns } from "./ClassifierEditableValuesListItem.vue?vue&type=template&id=6adfd017&lang=pug&"
import script from "./ClassifierEditableValuesListItem.vue?vue&type=script&lang=js&"
export * from "./ClassifierEditableValuesListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports